import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@beyond-js/ui/react';

/**
 * A link to a screen of this interface drawn as the shared button, so it has the family's control size:
 * a plain click is followed in the application, any other opens the address as a link does.
 */
export function Go({ to, label, variant = 'secondary' }: { to: string; label: string; variant?: 'primary' | 'secondary' | 'quiet' }) {
	const navigate = useNavigate();
	return (
		<Button
			href={to}
			variant={variant}
			label={label}
			onClick={(event: MouseEvent<HTMLElement>) => {
				if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
				event.preventDefault();
				navigate(to);
			}}
		/>
	);
}
